import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 11 1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 1\" id=\"minus\"><path d=\"M10.504.004c.26 0 .496.213.496.496a.499.499 0 0 1-.496.496H.496A.499.499 0 0 1 0 .5C0 .217.236.004.496.004h10.008z\" fill=\"#626469\" fill-rule=\"evenodd\" fill-opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol